import {
  ContentLayout,
  HeaderBreadcrumbs,
  Loader,
  NewFormCardWrapper,
} from "../../../shared";
import * as React from "react";
import {
  Button,
  Card,
  Divider,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { usePosSettings } from "../hooks";
import SimpleReactValidator from "simple-react-validator";
import { useState } from "react";
import { useRef } from "react";
import { DenominationField } from "../components";

export const PosSettingsDetails = () => {
  const [, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const {
    state,
    onRadioButtonChange,
    handleOnChange,
    onUpdateTemplate,
    handleQuickCashChange,
    stateTemplates,
  } = usePosSettings({
    isList: true,
  });
  const optionTemplates = stateTemplates?.templates?.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const optionWastageTemplates = stateTemplates?.wastageTemplate?.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const onSubmit = () => {
    if (validator.current.allValid()) {
      onUpdateTemplate();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const quickCashValidation = {
    slot_1: validator.current.message(
      "Slot 1",
      state?.quick_cash?.[0],
      "required|numeric",
    ),
    slot_2: validator.current.message(
      "Slot 2",
      state?.quick_cash?.[1],
      "required|numeric",
    ),
    slot_3: validator.current.message(
      "Slot 3",
      state?.quick_cash?.[2],
      "required|numeric",
    ),
    slot_4: validator.current.message(
      "Slot 4",
      state?.quick_cash?.[3],
      "required|numeric",
    ),
    slot_5: validator.current.message(
      "Slot 5",
      state?.quick_cash?.[4],
      "required|numeric",
    ),
  };
  const allSlotsAreValid = Object.entries(validator.current.fields)
    .filter(([key]) => key.startsWith("Slot"))
    .some(([_, value]) => !value);

  return (
    <>
      <ContentLayout
        title="POS Settings"
        breadcrumbs={
          <>
            <HeaderBreadcrumbs
              links={[
                { name: "Dashboard", href: "/" },
                { name: "POS Settings" },
              ]}
            />
          </>

        }
        rightContent={<>
          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={!state.hasChanges || state.isSaveButtonBusy}
          >
            Save
          </Button>
        </>}
      >
        <Card sx={{ p: "32px 24px", mb: "24px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle1" fontWeight={600}>
                Product Display View
              </Typography>
            </Grid>
            <Grid item sm={8}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="discount_type"
              >
                <FormControlLabel
                  control={<Radio />}
                  label="Image View"
                  checked={state.display_mode === "image" ? true : false}
                  value={state.display_mode}
                  onChange={() => onRadioButtonChange("image", "display_mode")}
                />
                <FormControlLabel
                  value={state.display_mode}
                  control={<Radio />}
                  label="Text View"
                  checked={state.display_mode === "text" ? true : false}
                  onChange={() => onRadioButtonChange("text", "display_mode")}
                />
              </RadioGroup>
            </Grid>
          </Grid>
        </Card>

        <Card
          sx={{
            p: "32px 24px",
            mb: "24px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <Typography variant="subtitle1" fontWeight={600}>
                Sales Keypad Template
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle1" fontWeight={400}>
                Product Listing Mode
              </Typography>
            </Grid>
            <Grid item sm={8}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="discount_type"
              >
                <FormControlLabel
                  control={<Radio />}
                  label="Grid Mode"
                  value={state.display_position}
                  checked={state.display_position === "grid" ? true : false}
                  onChange={() =>
                    onRadioButtonChange("grid", "display_position")
                  }
                />
                <FormControlLabel
                  value={state.display_position}
                  control={<Radio />}
                  label="Dynamic Mode"
                  checked={state.display_position === "dynamic" ? true : false}
                  onChange={() =>
                    onRadioButtonChange("dynamic", "display_position")
                  }
                />
              </RadioGroup>
            </Grid>
          </Grid>
          {state.display_position === "grid" && (
            <>
              <Stack mt={2}>
                <Divider />
              </Stack>
              <Grid container spacing={1} marginTop={4}>
                <Grid item sm={4}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{ width: "150px" }}
                  >
                    Default Template
                  </Typography>
                </Grid>

                <Grid item sm={8}>
                  <Grid container spacing={1}>
                    <Stack direction="row" gap={1}>
                      <InputControl
                        type="dropdown"
                        name="keypad_id"
                        sx={{
                          width: "635px",
                        }}
                        disableClearable
                        options={optionTemplates}
                        filteredOptions
                        getOptionLabel={(option) => option?.label}
                        onChange={(e, newValue) => {
                          handleOnChange("keypad_id", newValue);
                        }}
                        value={
                          (optionTemplates?.length > 0 &&
                            state?.keypad_id &&
                            optionTemplates?.find(
                              (c) => c.value === state?.keypad_id
                            )) ||
                          null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            sx={{
                              borderRadius: "8px",
                              ".MuiInputBase-root": { height: "44px" },
                            }}
                            label="Default Template"
                            required
                            error={validator.current.message(
                              "Default Template",
                              state?.keypad_id,
                              "required"
                            )}
                            helperText={validator.current.message(
                              "Default Template",
                              state?.keypad_id,
                              "required"
                            )}
                          />
                        )}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Card>
        <Card
          sx={{
            p: "32px 24px",
            mb: "24px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <Typography variant="subtitle1" fontWeight={600}>
                Wastage Keypad Template
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle1" fontWeight={400}>
                Product Listing Mode
              </Typography>
            </Grid>
            <Grid item sm={8}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="discount_type"
              >
                <FormControlLabel
                  control={<Radio />}
                  label="Grid Mode"
                  value={state.wastage_display_position}
                  checked={state.wastage_display_position === "grid" ? true : false}
                  onChange={() =>
                    onRadioButtonChange("grid", "wastage_display_position")
                  }
                />
                <FormControlLabel
                  value={state.wastage_display_position}
                  control={<Radio />}
                  label="Dynamic Mode"
                  checked={state.wastage_display_position === "dynamic" ? true : false}
                  onChange={() =>
                    onRadioButtonChange("dynamic", "wastage_display_position")
                  }
                />
              </RadioGroup>
            </Grid>
          </Grid>
          {state.wastage_display_position === "grid" && (
            <>
              <Stack mt={2}>
                <Divider />
              </Stack>
              <Grid container spacing={1} marginTop={4}>
                <Grid item sm={4}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{ width: "150px" }}
                  >
                    Default Template
                  </Typography>
                </Grid>

                <Grid item sm={8}>
                  <Grid container spacing={1}>
                    <Stack direction="row" gap={1}>
                      <InputControl
                        type="dropdown"
                        name="wastage_keypad_id"
                        sx={{
                          width: "635px",
                        }}
                        disableClearable
                        options={optionWastageTemplates}
                        filteredOptions
                        getOptionLabel={(option) => option?.label}
                        onChange={(e, newValue) => {
                          handleOnChange("wastage_keypad_id", newValue);
                        }}
                        value={
                          (optionWastageTemplates?.length > 0 &&
                            state?.wastage_keypad_id &&
                            optionWastageTemplates?.find(
                              (c) => c.value === state?.wastage_keypad_id
                            )) ||
                          null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            sx={{
                              borderRadius: "8px",
                              ".MuiInputBase-root": { height: "44px" },
                            }}
                            label="Default Template"
                            required
                            error={validator.current.message(
                              "Default Template",
                              state?.wastage_keypad_id,
                              "required"
                            )}
                            helperText={validator.current.message(
                              "Default Template",
                              state?.wastage_keypad_id,
                              "required"
                            )}
                          />
                        )}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Card>
        <NewFormCardWrapper title="Quick Cash Currencies" gap="12px" titleColor="text.primary">
          <>
            <Typography fontSize="12px" color="textSecondary">
              Manage the default denominations shown under Quick Cash in POS.
            </Typography>
            <Stack gap="12px" mt="12px">
              <Typography variant="caption">Default Denominations</Typography>
              <Stack direction="row" gap="12px" flexWrap="wrap">
                {state.isBusy ? (
                  <Stack
                    alignItems="center"
                    justifyContent="center"
                    width="100%"
                  >
                    <Loader />
                  </Stack>
                ) : (
                  <Stack gap="12px">
                    <Stack display="grid" gridAutoFlow="column" gap="12px">
                      {Array.from({ length: 5 }).map((_, index) => (
                        <DenominationField
                          key={index}
                          type="number"
                          value={state?.quick_cash?.[index] || ""}
                          error={quickCashValidation[`slot_${index + 1}`]}
                          onChange={(e) => {
                            handleQuickCashChange(
                              index,
                              parseInt(e.target.value),
                            );
                          }}
                        />
                      ))}
                    </Stack>
                    {allSlotsAreValid && (
                      <FormHelperText sx={{ color: "error.main" }}>
                        All slots are required
                      </FormHelperText>
                    )}
                  </Stack>
                )}
              </Stack>
            </Stack>
          </>
        </NewFormCardWrapper>
      </ContentLayout>
    </>
  );
};
